export function convertKeysToLowerCamelCase(obj: any): any {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(convertKeysToLowerCamelCase);
    }

    const newObj: { [key: string]: any } = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            newObj[toCamelCase(key)] = convertKeysToLowerCamelCase(obj[key]);
        }
    }
    return newObj;
}

// Mirrors Newtonsoft's StringUtils.ToCamelCase so that the keys we produce
// match what the C# API/firmware emit (e.g. "FHWAType" -> "fhwaType",
// "URL" -> "url", "URLPath" -> "urlPath", "LastFrameTracked" -> "lastFrameTracked").
// Idempotent for keys that are already camelCase.
function toCamelCase(s: string): string {
    if (!s || !isAsciiUpper(s[0])) {
        return s;
    }

    const chars = s.split("");
    for (let i = 0; i < chars.length; i++) {
        if (i === 1 && !isAsciiUpper(chars[i])) {
            break;
        }
        const hasNext = i + 1 < chars.length;
        if (i > 0 && hasNext && !isAsciiUpper(chars[i + 1])) {
            break;
        }
        chars[i] = chars[i].toLowerCase();
    }
    return chars.join("");
}

function isAsciiUpper(c: string): boolean {
    return c >= "A" && c <= "Z";
}
